import confetti from 'canvas-confetti';

/**
 * Простой залп конфетти — для мелких событий (XP, маленькие ачивки)
 */
export function fireConfetti() {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#10E58E', '#3DD8FF', '#FFA52E', '#FFFFFF'],
  });
}

/**
 * Двойной залп с боков — для разблокировки ачивки
 * Длится 2 секунды
 */
export function fireAchievementConfetti() {
  const duration = 2 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = { 
    startVelocity: 30, 
    spread: 360, 
    ticks: 60, 
    zIndex: 100,
    colors: ['#10E58E', '#3DD8FF', '#FFA52E', '#FFFFFF'],
  };

  function randomInRange(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  const interval: any = setInterval(() => {
    const timeLeft = animationEnd - Date.now();
    if (timeLeft <= 0) return clearInterval(interval);
    
    const particleCount = 50 * (timeLeft / duration);
    
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
    });
  }, 250);
}

/**
 * Большой залп — для повышения уровня (level up)
 */
export function fireLevelUpConfetti() {
  confetti({
    particleCount: 200,
    spread: 100,
    origin: { y: 0.5 },
    colors: ['#10E58E', '#3DD8FF', '#FFA52E', '#FFFFFF'],
    startVelocity: 45,
  });
  
  // Второй залп через 250мс — двойной взрыв
  setTimeout(() => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#10E58E', '#3DD8FF', '#FFFFFF'],
    });
  }, 250);
}
